export enum Partner {
  AirCanada = '4ef186ee-e6b5-467d-bfb2-0d31c78ea5db',
  HtsAirline = 'hts-airline',
  VirginAustralia = 'bcd0b2a1-d2d1-4a9e-ad3c-b5122b70dc58',
  Volaris = '00e30494-bdfb-4815-8a39-f9ec3e1e5caf',
  AirAsia = '72f970df-78a4-463c-b455-a8f77a3eb37c',
  Flair = `a3f39f5f-1b09-46a9-9243-9f7b8160a8ce`,
}
